import {PATH_STRINGS} from "../routes/route-props";
import {FusionAuthConfig} from '@fusionauth/react-sdk';

export const config: FusionAuthConfig = {
    clientID: `${process.env.REACT_APP_FUSION_AUTH_CLIENT_ID}`,
    redirectUri: `${process.env.REACT_APP_BASE_ENDPOINT_FUSION_AUTH_REDIRECT_URI}${PATH_STRINGS.redirectOnSuccessfulLogin}`,
    serverUrl: `${process.env.REACT_APP_BASE_ENDPOINT_FUSION_AUTH_SERVER_URL}`
}